import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Icon from "@mui/material/Icon";
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import { Stack } from "@mui/material";
import { makeStyles, useTheme } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import { ThreeDots } from 'react-loader-spinner';
import { useDropzone } from "react-dropzone";
import { useDropzone2 } from "react-dropzone";
import "layouts/style.css";
import { Bars } from 'react-loader-spinner'
import Select from "react-select"
import { saveCustomerPortalForm1 } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import CloseIcon from '@mui/icons-material/Close';
import {Dialog, DialogTitle, DialogContent, DialogActions} from "@mui/material";
import Table from 'react-bootstrap/Table';
import {FormGroup, FormControlLabel} from "@mui/material";
import { fetchKDSCustomer } from "assets/globalAPI/apiGlobal";
import { fetchKDSMaterial } from "assets/globalAPI/apiGlobal";
import { fetchKDSVendor } from "assets/globalAPI/apiGlobal";
import { fetchAllCustomer } from "assets/globalAPI/apiGlobal";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const CustomerForm=()=>{
    const navigate= useNavigate();
    const [loaderspinner, setLoaderSpinner] = useState(false);
    const [isMsme, setIsMsme] = useState(false);
    const [isfssi, setIsFssi] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [searchLoader, setSearchLoader] = useState(false);
    const [customerType, setCustomerType] = useState("");
    const toastId = React.useRef(null);
    const [loader, setLoader] = useState(false);
    const[firmtypes,setFirmTypes]= useState([]);
    const [formSubmitted, setIsFormSubmiteed] = useState(false);
    const contactEmail= localStorage.getItem("contactPersonEmail")
    const contactMobile= localStorage.getItem("contactPersonMobile")
    const [refID, setRefID] = useState(localStorage.getItem("refId") || ""); 
    const [kdsdata,setKdsData]= useState({});
    const [kdsdata2,setKdsData2]= useState({});
    const [kdsdata3,setKdsData3]= useState({});
    const [dialogOpen,setDialogOpen]= useState(false);
    const [dialogOpen2,setDialogOpen2]= useState(false);
    const [panGSTError,setPanGSTError]= useState(false);
    const [panGSTError2,setPanGSTError2]= useState(false);
    const [searchTerm,setSearchTerm]= useState("");
    const [searchTerm2,setSearchTerm2]= useState("");
    const [gstAvailable,setGstAvailable]= useState("Yes");
    const [fssiAvailable,setFssiAvailable]= useState("Yes");
     const [keySelected,setKeySelected]= useState("");
     const [godownUnit,setGodownUnit]= useState("");
     const [customerState,setCustomerState]= useState([])
     const [filteredZone,setFilteredZone]= useState([])
     const [custTitle,setCustTitle]= useState([])
     const [customerArr,setCustomerArr]= useState([])
     const [titleName,setTitleName]= useState("");

     const [zData,setZData]= useState([]);
        const [selectedField,setSelectedField]= useState("");
        const [stateSelected,setStateSelected]=useState("")
        const [selectedZoneName,setSelectedZoneName]=useState("")
        const [selectedKeyName,setSelectedKeyName]=useState("")
        const [debouncedSearch, setDebouncedSearch] = useState("");
    const [formValues, setFormValues] = useState({
      reference_id: '',
      firm_name: '',
      firm_status:'',
      street: '',
      co_name:'',
      po_box: '', 
      city: '',
      customer_type: '',
      district_name: '',
      block_tehsil: '',
      main_town_village: '', 
      post_office: '', 
      police_station: '',
      state: '', // State*
      pin_code: '', // Pin Code*
      proprietor_name: '', 
      proprietor_dob: '', 
      proprietor_email: '', 
      proprietor_mobile: '', 
      pan: '', 
      aadhaar: '', 
      cin: '', 
      roc_status:'', 
      inpln: '', 
      contact_person: '', 
      contact_person_email: contactEmail, 
      contact_person_mobile: contactMobile?.toString(),
      mobile:'',
      email:'',
      contact_person_telephone: '',
      fssi_registration_status: '', 
      fssi_regn_no: '', 
      gstn: '', 
      tan: '', 
      bank_name: '',
      bank_branch_name: '',
      ifsc_code: '', // IFSC Code
      bank_account_number: '',
      undated_cheque_1: '',
      undated_cheque_2: '',
      undated_cheque_3: '',
      miscellaneous: '',
      companies: [
        { name_of_company: '', company_brand: '', monthly_turnover: '' }
      ],
      godown_area: '',
      godown_type: '',
      rcc_structure: '',
      del_type_rickshaw:'',
      del_type_van:'',
      model_no_van:'',
      customer_salesman_1: '',
      customer_salesman_no_1: '',
      customer_salesman_2: '',
      customer_salesman_no_2: '',
      customer_weekoff: '',
      date_of_fillup: new Date().toISOString().split('T')[0].replaceAll("-", ""),

      marketDetails: {
        Monday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: ""
          }
        ],
        Tuesday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          }
        ],
        Wednesday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          }
         
        ],
        Thursday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          },
        ],
        Friday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          },
        ],
        Saturday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          },
        ],
        Sunday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          },
        ],
      },
    });

    function capitalizeInitials(str) {
      return str
        .split(/(\s+)/) // this keeps the spaces too
        .map(word => {
          return word.trim() ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word;
        })
        .join('');
    }

     const fetchCustomers=async(status)=>{
        setIsActive(true)
        let body;

          body={
           page: 1,
           reference_id: localStorage.getItem("refId"),
         }
    
        try{
          const response= await fetchAllCustomer(body);
          const res= response.data;
          console.log("printing res>>> ", res);
          if(res.status){
            console.log("fetched custs>> ", res.data);
            setIsActive(false)
            setCustomerArr(res.data);
            const updatedValues = {};

      
     
    
      Object.keys(formValues).forEach((key) => {
        if (res.data[0].hasOwnProperty(key)) {
          if (key === "marketDetails" && Array.isArray(res.data[0].marketDetails)) {
            // Format marketDetails properly
            const formattedMarketDetails = {
              Monday: [],
              Tuesday: [],
              Wednesday: [],
              Thursday: [],
              Friday: [],
              Saturday: [],
              Sunday: []
            };
    
            res.data[0].marketDetails.forEach((detail) => {
              const day = detail.day;
              if (formattedMarketDetails[day]) {
                formattedMarketDetails[day].push(detail);
              }
            });
    
            updatedValues[key] = formattedMarketDetails;
          } else if (key === "godown_area") {
            const [area, unit] = res.data[0].godown_area.split(" ");
            updatedValues[key] = res.data[0].godown_area;
            setGodownUnit(unit); // Assuming you have a godownUnit state setter
          }
                   
         else {
            updatedValues[key] = res.data[0][key] || '';
          }
        } else {
          updatedValues[key] = formValues[key];
        }
      });

    
      setFormValues(updatedValues);
      console.log("Updated simple form >>>", updatedValues);
          }else{
            console.log("not fetched custs>> ", res);
            setCustomerArr([]);
            setIsActive(false)
          }
        }catch(error){
          console.log("err in cust fetch>> ", error);
          setIsActive(false)
           if(error.response?.status==403){
                      if(!toast.isActive(toastId.current)){
                        toastId.current= toast.error("Your Session has expired",{
                          className:"small-toast"
                        })
                      }
                      setTimeout(()=>{
                        navigate("/")
                        localStorage.clear();
                      },2000)
                      return;
                    }
        }
      }

      

     const fetchAllCustomerKDS=async()=>{
                try{
                  const response= await fetchKDSMaterial();
                  const res= response.data;
                  if(res.status){
                    setKdsData(res.data)
                    console.log("kds fetched>> ", res.data);
                  }else{
                    console.log("could not bring material kds>> ", res)
                  }
                }catch(error){
                  console.log("error bringing material KDS>> ", error);
                }
              }

              const fetchAllVendorKDS=async()=>{
                try{
                  const response= await fetchKDSVendor();
                  const res= response.data;
                  if(res.status){
                    // setKdsData3(res.data)
                    // setCustTitle(res.data.title)
                    console.log("kds fetched vend>> ", res.data);
                  }else{
                    console.log("could not bring vendor kds>> ", res)
                  }
                }catch(error){
                  console.log("error bringing vendor KDS>> ", error);
                }
              }

              const fetchAllCustomerKDS2=async()=>{
                try{
                  const response= await fetchKDSCustomer();
                  const res= response.data;
                  if(res.status){
                    setKdsData2(res.data)
                    setCustTitle(res.data.title)
                    setCustomerState(res.data.region)
                    setZData(res.data.miszone)
                    console.log("kds fetched for cust>> ", res.data);
                  }else{
                    console.log("could not bring cust kds>> ", res)
                  }
                }catch(error){
                  console.log("error bringing cust KDS>> ", error);
                }
              }

     useEffect(() => {
          if (refID) {
            setFormValues((prevValues) => ({
              ...prevValues,
              reference_id: refID,
            }));
            console.log("ref id is>> ", refID)
          }
        }, [refID]);

        useEffect(() => {
          
        }, [searchTerm]);

    useEffect(() => {
      const isAuthenticate= localStorage.getItem("isAuthenticated");
      // if(!isAuthenticate){
      //   navigate("/customer/validation");
      //   return;
      // }
      fetchAllCustomerKDS();
      fetchAllCustomerKDS2()
      fetchAllVendorKDS()
      fetchCustomers();
      let cust_type= localStorage.getItem("customer_type");
      setFormValues(prev => ({
        ...prev,
        customer_type: cust_type || '',
      }));

      console.log("hvgdhw>> ", cust_type)
      
        setCustomerType(cust_type);
        let localForm = localStorage.getItem("customerForm2");
      let parsedFrom= JSON.parse(localForm)
      console.log("what is in form>>> ", JSON.parse(localForm))
      if(parsedFrom!==null){
        setFormValues(JSON.parse(localForm))
      }
    },[]);
    

  //   const handleFormChange = (field, value) => {
  //     let updatedValue = value;
  
  //     // Check if the field is one of the multi-selects
  //     if (field === "nature_of_business" || field === "business_category") {
  //         // For multi-select fields, we need to extract the 'value' from the selected options array
  //         updatedValue = value.map(option => option.value);
  //     }
  
  //     // Update the state for the given field
  //     setFormValues((prevState) => ({
  //         ...prevState,
  //         [field]: {
  //             ...prevState[field],
  //             value: updatedValue,
  //         },
  //     }));
  // };

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchLoader(true); // Show loader AFTER 2 sec pause
      setDebouncedSearch(searchTerm);
  
      // Simulate async filtering (optional delay or set false immediately after)
      setTimeout(() => {
        setSearchLoader(false); // Hide loader after data is "ready"
      }, 100); // tweak delay if needed
    }, 600); // Wait for user to stop typing
  
    return () => clearTimeout(handler); // Cleanup if typing again
  }, [searchTerm]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchLoader(true); // Show loader AFTER 2 sec pause
      setDebouncedSearch(searchTerm2);
  
      // Simulate async filtering (optional delay or set false immediately after)
      setTimeout(() => {
        setSearchLoader(false); // Hide loader after data is "ready"
      }, 100); // tweak delay if needed
    }, 600); // Wait for user to stop typing
  
    return () => clearTimeout(handler); // Cleanup if typing again
  }, [searchTerm2]);

  const filteredData = kdsdata.matuom?.filter(
    (item) =>
      item.label.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
      item.value.toLowerCase().includes(debouncedSearch.toLowerCase())
  );

  const filteredData2 = filteredZone?.filter(
    (item) =>
      item.toLowerCase().includes(searchTerm2.toLowerCase())
  );

  const handleFormChange = (field, value, index = null, day = null) => {
    if(field==="godown_unit"){
      setGodownUnit(value)
      setFormValues(prev => ({
        ...prev,
        godown_area: prev.godown_area.split(" ")[0] + (value ? ` ${value}` : "")
      }));
      setDialogOpen(false)
      setDialogOpen2(false)
      return;
    }
    setFormValues((prevState) => {
        let updatedState = { ...prevState };

        // Update companies only if index is provided and day is null
        if (index !== null && day === null) {
            const updatedCompanies = [...prevState.companies];
            updatedCompanies[index] = {
                ...updatedCompanies[index],
                [field]: value,
            };
            updatedState.companies = updatedCompanies;
        } 
        
        // Update marketDetails only if day is provided
        else if (day !== null && index !== null) {
          const updatedDays = { ...prevState.marketDetails };
          updatedDays[day][index] = {
              ...updatedDays[day][index],
              [field]: value,
          };
          updatedState.marketDetails = updatedDays;
      } 
        // General field update
        else {
            updatedState[field] = value;
            setDialogOpen2(false)
            setSearchTerm2("")
        }

        console.log("here is formValues after change>> ", updatedState)
        // setDialogOpen(false)
        setDialogOpen2(false)
        setSearchTerm("")

        return updatedState;
    });
};




  // const handleFormChange = (index, field, value) => {
  //   setFormValues((prevState) => {
  //     const updatedCompanies = [...prevState.companies];
  //     updatedCompanies[index] = {
  //       ...updatedCompanies[index],
  //       [field]: { ...updatedCompanies[index][field], value },
  //     };
  //     return { ...prevState, companies: updatedCompanies };
  //   });
  // };

  const addRow = () => {
    setFormValues((prevState) => ({
      ...prevState,
      companies: [
        ...prevState.companies,
        { name_of_company: '', company_brand: '', monthly_turnover: '' }
      ],
    }));
  };

  function formatDate(value) {
    if (!value) return '';
  
    // If value is already in YYYYMMDD format
    if (typeof value === 'string' && value.length === 8 && /^\d{8}$/.test(value)) {
      const year = value.substring(0, 4);
      const month = value.substring(4, 6);
      const day = value.substring(6, 8);
      return `${year}-${month}-${day}`;
    }
  
    // If value is in YYYY-MM-DD or similar format
    const dateObj = new Date(value);
  
    // If date is valid, format it
    if (!isNaN(dateObj.getTime())) {
      return dateObj.toISOString().split('T')[0];
    }
  
    // If invalid, don't touch it. Let the user keep typing.
    return value;
  }
  
  

  const formatToDDMMYYYY = (rawStr) => {
    if (!/^\d{8}$/.test(rawStr)) return "";
  
    const year = rawStr.slice(0, 4);
    const month = rawStr.slice(4, 6);
    const day = rawStr.slice(6, 8);
  
    return `${day}-${month}-${year}`;
  };

  const addRowMarket = (day) => {
    setFormValues((prevState) => {
      const updatedDays = { ...prevState.marketDetails };
      updatedDays[day].push({
        beatName: "",
        distanceFromGodown: "",
        expectedDailySales: "",
        retailer: "",
        wholesaler: "",
        frequencyOfVisit: "",
        readyStockOrOrderBooking: "",
      });
  
      return { ...prevState, marketDetails: updatedDays };
    });
  };

  const removeRowMarket = (day, index) => {
    setFormValues((prevState) => {
      const updatedDays = { ...prevState.marketDetails };
      
      if (updatedDays[day].length > 1) {
        updatedDays[day].splice(index, 1);
      }
  
      return { ...prevState, marketDetails: updatedDays };
    });
  };
  
  
  
  const removeRow = (index) => {
    setFormValues((prevState) => {
      const updatedCompanies = prevState.companies.filter((_, i) => i !== index);
      return { ...prevState, companies: updatedCompanies };
    });
  };
  

      const handleSubmitForm=async(e)=>{
        e.preventDefault();
        setIsActive(true)
        console.log("here is the final form>> ", formValues)
        setIsFormSubmiteed(true);
        let requiredFields;
        if(gstAvailable=="Yes"){
          if(formValues.gstn==""){
             if (!toast.isActive(toastId.current)) {
            toastId.current = toast.error(`Please fill GSTIN Number`, {
              className: "small-toast"
            });
          }
          
          setIsActive(false);
          
          return;
          }
        }
        if(fssiAvailable=="Yes"){
          if(formValues.fssi_regn_no==""){
             if (!toast.isActive(toastId.current)) {
            toastId.current = toast.error(`Please fill FSSAI Number`, {
              className: "small-toast"
            });
          }
          
          setIsActive(false);
          
          return;
          }
        }
        if(formValues.customer_type=="Sub Distributor"){

          requiredFields = [
           "firm_name", "firm_status", "city","street",
           "state", "pin_code","district_name", "proprietor_name", "proprietor_email", "proprietor_mobile","proprietor_dob",
           "contact_person", "contact_person_email", "contact_person_mobile"
            
         ];
        }else{
          requiredFields = [
           "firm_name", "firm_status", "city","street",
           "state", "pin_code","district_name", "proprietor_name", "proprietor_email", "proprietor_mobile","proprietor_dob","gstn", "pan",
           "contact_person", "contact_person_email", "contact_person_mobile"
            
         ];
        }

        const godownAreaFilled = formValues.godown_area && formValues.godown_area.trim() !== '';
        const godownUnitFilled = godownUnit && godownUnit.trim() !== '';

        
        
        let hasError = false;
        let updatedValues = { ...formValues };
        let missingFields = [];
        
        requiredFields.forEach((key) => {
      if (godownAreaFilled) {
        if(!godownUnitFilled){
          hasError = true;
          missingFields.push("godown_unit");
        }
        // hasError = true;
        // if (!godownAreaFilled) missingFields.push("godown_area");
      }
      const value = updatedValues[key];
    
      if (typeof value === 'string') {
        if (value.trim() === '') {
          hasError = true;
          missingFields.push(key.replace(/_/g, ' '));
        } else {
          updatedValues[key] = value.trim();
        }
      } else if (value === undefined || value === null) {
        hasError = true;
        missingFields.push(key.replace(/_/g, ' '));
      }
    });
    

    setFormValues(updatedValues); 
     if (hasError) {
          console.log("cannot submit, fill mandatory")
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.error(`Please fill all required fields: ${missingFields}`, {
              className: "small-toast"
            });
          }
          
          setIsActive(false);
          
          return;
        }

        console.log("here is the final form>> ", formValues)
        localStorage.setItem("customerForm", JSON.stringify(formValues))
        localStorage.setItem("customerForm2", JSON.stringify(formValues))
        // localStorage.setItem("filledForm2", JSON.stringify(formValues))
        // alert("Registration sucessful");
        // navigate("/customer/registration-form-2")



        try{
          const response= await saveCustomerPortalForm1(formValues);
          const res= response.data;
          console.log("here is response>> ", res);
          if(res.status){
            if (!toast.isActive(toastId.current)) {
              toastId.current = toast.success(res.message, {
                className: "small-toast"
              });
            }
            setIsActive(false)
            console.log("success in submitting>> ", res)
            navigate("/customer/registration-form-2")
          }else{
            if (!toast.isActive(toastId.current)) {
              toastId.current = toast.warning(res.message, {
                className: "small-toast"
              });
            }
            setIsActive(false)
            console.log("not success in submitting>> ", res)
          }
        }catch(error){
          console.log("Error saving customer details>> ", error);
           if (!toast.isActive(toastId.current)) {
                  toastId.current = toast.error(error.message, {
                    className: "small-toast"
                  });
                }
                setIsActive(false)
        }
      }

    return(
      <>
     <Grid>
      <SimpleBackdrop openLoader={isActive}/>
      <ToastContainer/>

       <SoftBox py={0} className="customerblock">
       <Grid container spacing={3}>
       <Grid item xs={12} lg={12} className="headerForm">
       
       <SoftBox p={0} display="flex" alignItems="center" justifyContent="space-between">
<img src={anmolLogo} alt="Logo" style={{ height: 100 }} />

<SoftTypography  variant="h3" id="form_heading" style={{ flex: 1, textAlign: "center" }}>
 Customer Registration
</SoftTypography>

{/* This empty box ensures the text remains centered */}
<div style={{ width: 50 }}></div>
</SoftBox>


       <Grid>
                     {loaderspinner ? <div style={{
                       position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                       zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                     }}>
                       <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />

                     </div> : ""}
       </Grid>
       
       </Grid>
       </Grid>
       </SoftBox>
        
        <SoftBox className="bp formBG">
          <form noValidate onSubmit={handleSubmitForm}>
         <SoftBox py={3} className="customerblock">
           <Grid container spacing={3}>
             <Grid item xs={12} lg={12}>
               <Card sx={{ overflow: "visible" }}>
                 <SoftBox p={3}>
                   <SoftTypography variant="h5" id="form_heading textUppercase">Customer Details</SoftTypography>

                   

                   <SoftBox mt={1}>
                     <Grid container spacing={3}>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Name of Firm*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="firm_name"
                             id="firm_name"
                             inputProps={{maxLength:40}}
                            //  error={formValues.firm_name.error} 
                             value={formValues.firm_name}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('firm_name', wordCapital)}}
                             
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Status of Firm*
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="firm_status"
                             id="address"
                            options={custTitle}
                            value={[
                              { value: formValues.firm_status, label:titleName!==""? titleName: formValues.firm_status} // Set the selected state value here
                            ]}
                             onChange={(e) =>{
                              setTitleName(e.label)
                              handleFormChange('firm_status', e.value)}}
                             
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Street*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="street"
                             id="street"
                            inputProps={{maxLength: 60}}
                            //  value={formValues.office_address?.value || ''}
                             value={formValues.street}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('street', wordCapital)}}
                           onKeyDown={(e)=>{
                              if(e.target.value.length==60){
                                 if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Street Cannot be more than 60 characters", {
            className: "small-toast"
          });
        }
                              }
                            }}
                           />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               PO Box
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="po_box"
                             id="po_box"
                             inputProps={{maxLength:40}}
                            //  value={formValues.office_address?.value || ''}
                             value={formValues.po_box}
                             onChange={(e) => handleFormChange('po_box', e.target.value)}
                           
                           />
                         </SoftBox>
                       </Grid>
                     </Grid>
                   </SoftBox>

                   <SoftBox mt={1}>
                     <Grid container spacing={3}>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              State Name*
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             
                             id="state"
                             options = {customerState}
                              value={[
                                { value: formValues.state, label: stateSelected? stateSelected: formValues.state } // Set the selected state value here
                              ]}
                             onChange={(e) =>{
                              setStateSelected(e.label)
                              handleFormChange('state', e.value)}}
                             size="medium"
                            
                              />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Pin Code*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="pin_code"
                             name="pin_code"
                             inputProps={{maxLength:6}}
                             value={formValues.pin_code}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('pin_code', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                              if(e.target.value.length==6){
                                 if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Pin Code Cannot be more than 6 characters", {
            className: "small-toast"
          });
        }
                              }
                            }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               City*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="city"
                             id="city"
                             inputProps={{maxLength:40}}
                             value={formValues.city}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('city', wordCapital)}}
                           />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               District Name*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="district_name"
                             id="district_name"
                             readOnly
                             value={formValues.district_name}
                             onClick={(e) =>{
                              setSelectedKeyName("zzdist");
                              let filteredData = zData
                              .map(item => item.zzdist)
                              .filter(value => value && value.trim() !== '');
                              console.log("filtered districts>> ", filteredData)
                              setFilteredZone(filteredData)
                              setDialogOpen2(true)

                              setSelectedZoneName('district_name');
                             }}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Block/Tehsil/Taluka/Mandal Name
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="block_tehsil"
                             inputProps={{maxLength:70}}
                             value={formValues.block_tehsil}
                             onChange={(e) => handleFormChange('block_tehsil', e.target.value)}
                             size="medium" />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                       <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Main Town/Village Name
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="main_town_village"
                             id="main_town_village"
                            
                            value={formValues.main_town_village}
                            onClick={(e) =>{
                              let filteredData = zData
                              .map(item => item.zztown)
                              .filter(value => value && value.trim() !== '');
                              setFilteredZone(filteredData)
                              setDialogOpen2(true)

                              setSelectedZoneName('main_town_village');
                             }}
                             
                           />
                       </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                       <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                             
                             >
                               Post office
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="post_office"
                             
                             value={formValues.post_office}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('post_office', wordCapital)}}
                             size="medium"
                              />
                       </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Police Station
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="police_station"
                             name="police_station"
                            //  error={formValues.police_station.error}
                             value={formValues.police_station}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('police_station', wordCapital)}}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       {/* <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               disabled
                             >
                               Mobile*.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             
                             id="mobile"
                             name="mobile"
                              inputProps={{maxLength:10}}
                             value={formValues.mobile}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('mobile', onlyNumbers);
                            }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid> */}

                       {/* <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Email*.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="email"
                             name="email"
                              
                             value={formValues.email}
                             onChange={(e) => handleFormChange('email', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid> */}

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Name of Proprietor / Partners / Directors*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="proprietor_name"
                             name="proprietor_name"
                            
                             value={formValues.proprietor_name}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('proprietor_name', wordCapital)}}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Proprietor Contact No:-(WhatsApp No.)*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="proprietor_mobile"
                             name="proprietor_mobile"
                             inputProps={{ maxLength: 10 }}
                             value={formValues.proprietor_mobile}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('proprietor_mobile', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                              if(e.target.value.length==10){
                                 if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Mobile No Cannot be more than 10 digits", {
            className: "small-toast"
          });
        }
                              }
                            }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                             
                             >
                              Proprieter Email Id*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="proprietor_email"
                             name="proprietor_email"
                            
                             value={formValues.proprietor_email}    
                             onChange={(e) => handleFormChange('proprietor_email', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>


                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Date of Birth of Proprietor/Partner/Director*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="date"
                             id="proprietor_dob"
                             name="proprietor_dob"
                            
                             value={formatDate(formValues.proprietor_dob)}
                             onChange={(e) => {
                              const selectedDate = new Date(e.target.value);
                              const today = new Date();
                            
                              if (selectedDate > today) {
                                if (!toast.isActive(toastId.current)) {
                                  toastId.current = toast.warning("DOB cannot be a future date", {
                                    className: "small-toast",
                                  });
                                }
                                handleFormChange('proprietor_dob', '');
                                return; // don't update the state if it's an invalid future date
                              }
                            
                              const day = String(selectedDate.getDate()).padStart(2, '0');
                              const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
                              const year = selectedDate.getFullYear();
                            
                              const formattedDate = `${year}${month}${day}`;
                              handleFormChange('proprietor_dob', formattedDate);
                            }}
                            
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Name of Contact Person*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="contact_person"
                             name="contact_person"
                            
                             value={formValues.contact_person}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('contact_person', wordCapital)}}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Contact Person Telephone.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             inputProps={{ maxLength: 11 }}
                             id="contact_person_telephone"
                             name="contact_person_telephone"
                            
                             value={formValues.contact_person_telephone}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('contact_person_telephone', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                              if(e.target.value.length==11){
                                 if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Telephone No Cannot be more than 11 digits", {
            className: "small-toast"
          });
        }
                              }
                            }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Contact Person Mobile*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="mobile"
                             name="mobile"
                             inputProps={{ maxLength: 10 }}
                             value={formValues.contact_person_mobile || contactMobile}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('contact_person_mobile', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                              if(e.target.value.length==10){
                                 if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Mobile No Cannot be more than 10 digits", {
            className: "small-toast"
          });
        }
                              }
                            }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Contact Person Email*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="contact_person_email"
                             name="contact_person_email"
                            
                             value={formValues.contact_person_email|| contactEmail}
                             onChange={(e) => handleFormChange('contact_person_email', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                      
                       
                     </Grid>
                   </SoftBox>


                 
                   

                   

                 </SoftBox>
               </Card>
             </Grid>
           </Grid>
         </SoftBox>

         <SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
     <SoftTypography variant="h5" id="form_heading">Business Details</SoftTypography>


       <SoftBox mt={1}>
         <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               GSTIN Available
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             type="text"
                             id="pan"
                             name="roc_status"
                            value={[
                                {value: gstAvailable, label: gstAvailable } // Set the selected state value here
                            ]}
                            //  value={formValues.roc_status.value}
                             onChange={(e) => {
                              setGstAvailable(e.value)
                              localStorage.setItem("custGST", e.value)
                             }}
                             size="medium"
                             options={[
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"}
                             ]}
                             />
                         </SoftBox>
                       </Grid>
         <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               GSTIN No {formValues.customer_type!=="Sub Distributor" && <span>*</span>}.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="gstn"
                             name="gstn"
                            error={panGSTError2}
                             inputProps={{maxLength:15}}
                             value={formValues.gstn}
                             size="medium"
                             onChange={(e) => {
                              const gstn = e.target.value.trim();
                            
                              if (gstn === "") {
                                // setPanGSTError2(false)
                                setFormValues((prev) => ({
                                  ...prev,
                                  gstn: "",
                                  pan: "",
                                }));
                                return;
                              }
                            
                              const gstnRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
                            
                              if (gstnRegex.test(gstn)) {
                                const panFromGstn = gstn.substring(2, 12); // Extract PAN
                                console.log("pan is>> ", panFromGstn);
                                setFormValues((prev) => ({
                                  ...prev,
                                  gstn: gstn,
                                  pan: panFromGstn,
                                }));
                                setPanGSTError2(false)
                              } else {
                                if (!toast.isActive(toastId.current)) {
                                  toastId.current = toast.warning("Please fill a valid GSTIN number", {
                                    className: "small-toast",
                                  });
                                }
                                setFormValues((prev) => ({
                                  ...prev,
                                  gstn: gstn,
                                  pan: "", // Clear PAN if GSTN is invalid
                                }));
                                setPanGSTError2(true)
                              }
                            }}
                            
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               PAN number {formValues.customer_type!=="Sub Distributor" && <span>*</span>}.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="pan"
                             name="pan"
                             inputProps={{maxLength:10}}
                            error={panGSTError}
                             value={formValues.pan}
                             onChange={(e) => {
                              const pan = e.target.value.trim().toUpperCase();
                              const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
                            
                              if (pan === "") {
                                handleFormChange('pan', pan);
                                return;
                              }
                            
                              if (panRegex.test(pan)) {
                                setFormValues((prev) => ({
                                  ...prev,
                                  pan: pan,
                                }));
                                setPanGSTError(false)
                              } else {
                                if (!toast.isActive(toastId.current)) {
                                  toastId.current = toast.warning("Please enter a valid PAN number", {
                                    className: "small-toast",
                                  });
                                }
                                setPanGSTError(true)
                                setFormValues((prev) => ({
                                  ...prev,
                                  pan: pan,
                                }));
                              }
                            }}
                            
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>
                        <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               FSSAI Status
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             type="text"
                             id="pan"
                             name="roc_status"
                            value={[
                                {value: fssiAvailable, label: fssiAvailable } // Set the selected state value here
                            ]}
                            //  value={formValues.roc_status.value}
                             onChange={(e) => {
                              setFssiAvailable(e.value)
                              localStorage.setItem("custFssi", e.value)
                             }}
                             size="medium"
                             options={[
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"}
                             ]}
                             />
                         </SoftBox>
                       </Grid>
                       {fssiAvailable=="Yes" &&
                       
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               FSSAI No*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="fssi_regn_no"
                             name="fssi_regn_no"
                            inputProps={{maxLength:20}}
                             value={formValues.fssi_regn_no}
                             onChange={(e) => handleFormChange('fssi_regn_no', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>
                       }

                       

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Aadhaar (mandatory for proprietership firm).
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="aadhaar"
                             name="aadhaar"
                            
                             value={formValues.aadhaar}    
                             onChange={(e) => handleFormChange('aadhaar', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               TAN number.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="tan"
                             name="tan"
                            
                             value={formValues.tan}
                             onChange={(e) => handleFormChange('tan', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>


                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               CIN ( applicable for  LTD / PVT / LLP) .
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="cin"
                             name="cin"
                            
                             value={formValues.cin}
                             onChange={(e) => handleFormChange('cin', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               ROC status of company whether exist of strike of
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             type="text"
                             id="pan"
                             name="roc_status"
                            value={[
                                {value: formValues.roc_status, label: formValues.roc_status } // Set the selected state value here
                            ]}
                            //  value={formValues.roc_status.value}
                             onChange={(e) => {
                              localStorage.setItem("rocStatus",e.value)
                              handleFormChange('roc_status', e.value)}}
                             size="medium"
                             options={[
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"}
                             ]}
                             />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Investment Amount Plan for Anmol(Rs.)
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="inpln"
                             name="inpln"
                            
                             value={formValues.inpln}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('inpln', onlyNumbers);
                            }}
                             size="medium"
                             />
                         </SoftBox>
                       </Grid>

                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Non-IT Return 
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             id="inpln"
                             name="inpln"
                            
                             value={[
                              {value: formValues.non_it_return, label: formValues.non_it_return } // Set the selected state value here
                             ]}
                             options={[
                              {value:"Yes", label:"Yes"},
                              {value:"No", label:"No"}
                             ]}
                             onChange={(e) => handleFormChange('non_it_return', e.value)}
                             size="medium"
                             />
                         </SoftBox>
                       </Grid> */}
                       


         </Grid>
       </SoftBox>

     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

<SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
     <SoftTypography variant="h5" id="form_heading">Bank Details</SoftTypography>


       <SoftBox mt={1}>
         <Grid container spacing={3}>
         <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Bank Account No.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_account_number"
                             name="bank_account_number"
                            inputProps={{maxLength:20}}
                             value={formValues.bank_account_number}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('bank_account_number', onlyNumbers);}}
                             size="medium"
                             onKeyDown={(e)=>{
                              if(e.target.value.length==20){
                                 if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Account No Cannot be more than 20 digits", {
            className: "small-toast"
          });
        }
                              }
                            }}
                             
                             />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               IFSC Code.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="ifsc_code"
                             name="ifsc_code"
                            
                             value={formValues.ifsc_code}
                             onChange={(e) => handleFormChange('ifsc_code', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Bank Name.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_name"
                             name="bank_name"
                            
                             value={formValues.bank_name}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('bank_name', wordCapital)}}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Bank Branch Name.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_branch_name"
                             name="bank_branch_name"
                            
                             value={formValues.bank_branch_name}
                             onChange={(e) => handleFormChange('bank_branch_name', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Undated Cheque No. 1.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_branch_name"
                             name="bank_branch_name"
                            
                             value={formValues.undated_cheque_1}
                             onChange={(e) => handleFormChange('undated_cheque_1', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Undated Cheque No. 2.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_branch_name"
                             name="bank_branch_name"
                            
                             value={formValues.undated_cheque_2}
                             onChange={(e) => handleFormChange('undated_cheque_2', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Undated Cheque No. 3.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_branch_name"
                             name="bank_branch_name"
                            
                             value={formValues.undated_cheque_3}
                             onChange={(e) => handleFormChange('undated_cheque_3', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Miscellaneous.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_branch_name"
                             name="bank_branch_name"
                            
                             value={formValues.miscellaneous}
                             onChange={(e) => handleFormChange('miscellaneous', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

         </Grid>
       </SoftBox>

     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

<SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
     <SoftTypography variant="h5" id="form_heading" style={{marginBottom:'8px'}}>Other Information & Infastructure Details</SoftTypography>
     <SoftTypography variant="p" >Other Products details in which the Customer is dealing with, if any</SoftTypography>
     <SoftBox mt={1}>
     {formValues.companies.map((company, index) => (
      <div style={{borderBottom: "1px dashed rgb(233, 233, 233)", paddingBottom: "16px"}} key={index}>
     <Grid container spacing={3} key={index}>
    <React.Fragment key={index} >      
      <Grid item xs={12} sm={4}>
        <SoftBox >
          <SoftTypography variant="caption" fontWeight="bold">Name of the Company</SoftTypography>
          <SoftInput
            type="text"
            value={company.name_of_company}
            onChange={(e) => handleFormChange('name_of_company', e.target.value, index)}
          />
        </SoftBox>
      </Grid>
      <Grid item xs={12} sm={4}>
        <SoftBox >
          <SoftTypography variant="caption" fontWeight="bold">Brand</SoftTypography>
          <SoftInput
            type="text"
            value={company.company_brand}
            onChange={(e) => handleFormChange('company_brand', e.target.value, index)}
          />
        </SoftBox>
      </Grid>
      <Grid item xs={12} sm={4}>
        <SoftBox>
          <SoftTypography variant="caption" fontWeight="bold">Monthly Turnover</SoftTypography>
          <SoftInput
            type="text"
            inputProps={{maxLength: 8}}
            value={company.monthly_turnover}
            onChange={(e) => handleFormChange('monthly_turnover', e.target.value, index)}
          />
        </SoftBox>
      </Grid>
    </React.Fragment>
    </Grid>
    </div>
  ))}



{/* <Grid container spacing={1}>
  <Grid item xs={6} sm={4}>
    <SoftButton variant="contained" color="info"  onClick={addRow}>
      Add Row
    </SoftButton>
  </Grid>
  {formValues.companies.length > 1 && (
    <Grid item xs={6} sm={4}>
      <SoftButton variant="contained" color="error"  onClick={() => removeRow(formValues.companies.length - 1)}>
        Remove
      </SoftButton>
    </Grid>
  )}
</Grid> */}

<SoftBox mt={2} style={{display: "flex", justifyContent: "flex-end"}}>
<SoftButton variant="contained" color="info"  onClick={addRow}>
      Add Row
    </SoftButton>
          {formValues.companies.length > 1 && (
           
           <SoftButton variant="contained" style={{marginLeft:'12px'}} color="error"  onClick={() => removeRow(formValues.companies.length - 1)}>
           <DeleteIcon/>
         </SoftButton>
           
          )}
          </SoftBox>
     </SoftBox>
      
     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

<SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
<Grid item xs={12} lg={12}>
<Card sx={{ overflow: "visible" }}>
<SoftBox p={3}>
<SoftTypography variant="h5" id="form_heading">Storage details</SoftTypography>
<SoftBox mt={1}>
<Grid container spacing={3}>
<Grid item xs={12} sm={4}>
  <SoftBox mb={3}>
    <SoftTypography variant="caption" fontWeight="bold">
      Godown Area (sqft)
    </SoftTypography>
    <Box display="flex" alignItems="center" gap={1}>
      <SoftInput
        type="text"
        value={formValues.godown_area.split(" ")[0]}
        onChange={(e) => handleFormChange('godown_area', e.target.value)}
        sx={{ width: '70%' }} // adjust main input width
      />
      <TextField
        variant="outlined"
        size="small"
        aria-readonly
        placeholder="Unit"
        value={godownUnit}
        onClick={(e)=> setDialogOpen(true)}
        sx={{ width: '30%' }} // size of the extra box
      />
    </Box>
  </SoftBox>
</Grid>

      <Grid item xs={12} sm={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="caption" fontWeight="bold">Godown Type</SoftTypography>
          <SoftInput
        type="text"
        value={formValues.godown_type}
        onChange={(e) => handleFormChange('godown_type', e.target.value)}
        
      />
        </SoftBox>
      </Grid>
      <Grid item xs={12} sm={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="caption" fontWeight="bold">RCC Structure</SoftTypography>
          <SoftInput
        type="text"
        value={formValues.rcc_structure}
        onChange={(e) => handleFormChange('rcc_structure', e.target.value)}
        
      />
        </SoftBox>
      </Grid>
      <Grid item xs={12} sm={4}>
  <SoftBox mb={3}>
    <SoftTypography variant="caption" fontWeight="bold">Delivery Vehicle Type</SoftTypography>
    <FormGroup sx={{displaye:'flex', justifyContent:'space-between'}}>
      <FormControlLabel
        control={
          <Checkbox
          size="small"
            checked={formValues.del_type_rickshaw === "X"}
            onChange={(e) =>
              handleFormChange('del_type_rickshaw', e.target.checked ? "X" : "")
            }
          />
        }
        label={
          <SoftTypography variant="caption">Rickshaw</SoftTypography>
        }
      />
      <FormControlLabel
        control={
          <Checkbox
          size="small"
            checked={formValues.del_type_van === "X"}
            onChange={(e) =>
              handleFormChange('del_type_van', e.target.checked ? "X" : "")
            }
          />
        }
        label={
          <SoftTypography variant="caption">Auto Van</SoftTypography>
        }
      />
    </FormGroup>
  </SoftBox>
</Grid>

{formValues.del_type_van === "X" && (
  <Grid item xs={12} sm={4}>
    <SoftBox mb={3}>
      <SoftTypography variant="caption" fontWeight="bold">Auto Van Model</SoftTypography>
      <SoftInput
        type="text"
        value={formValues.model_no_van || ""}
        onChange={(e) => handleFormChange("model_no_van", e.target.value)}
      />
    </SoftBox>
  </Grid>
)}

<Grid container spacing={2} justifyContent="flex-start" style={{ marginLeft: '1%' }}>
  <Grid item xs={10} sm={3}>
    <SoftBox mb={3}>
      <SoftTypography variant="caption" fontWeight="bold">Salesman 1</SoftTypography>
      <SoftInput
        type="text"
        value={formValues.customer_salesman_1}
        onChange={(e) => {
          let wordCapital= capitalizeInitials(e.target.value)
          handleFormChange('customer_salesman_1', wordCapital)}}
      />
    </SoftBox>
  </Grid>
  
  <Grid item xs={12} sm={3}>
    <SoftBox mb={3}>
      <SoftTypography variant="caption" fontWeight="bold">Mobile 1</SoftTypography>
      <SoftInput
        type="text"
        inputProps={{maxLength:10}}
        value={formValues.customer_salesman_no_1}
        onChange={(e) => {
          const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
          handleFormChange('customer_salesman_no_1', onlyNumbers);

        }}
      />
    </SoftBox>
  </Grid>

  <Grid item xs={12} sm={3}>
    <SoftBox mb={3}>
      <SoftTypography variant="caption" fontWeight="bold">Salesman 2</SoftTypography>
      <SoftInput
        type="text"
        value={formValues.customer_salesman_2}
        onChange={(e) => {
          let wordCapital= capitalizeInitials(e.target.value)
          handleFormChange('customer_salesman_2', wordCapital)}}
      />
    </SoftBox>
  </Grid>

  <Grid item xs={12} sm={3}>
    <SoftBox mb={3}>
      <SoftTypography variant="caption" fontWeight="bold">Mobile 2</SoftTypography>
      <SoftInput
        type="text"
        inputProps={{maxLength:10}}
        value={formValues.customer_salesman_no_2}
        onChange={(e) => {
          const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
          handleFormChange('customer_salesman_no_2', onlyNumbers);

        }}
      />
    </SoftBox>
  </Grid>
</Grid>

      <Grid item xs={12} sm={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="caption" fontWeight="bold">Week Off Day Followed by Customer.</SoftTypography>
          <SoftInput
            type="text"
           value={formValues.customer_weekoff}
            onChange={(e) => handleFormChange( 'customer_weekoff', e.target.value)}
          />
        </SoftBox>
      </Grid>
</Grid>
</SoftBox>
</SoftBox>
</Card>
</Grid>
</Grid>
</SoftBox>

{customerType!=="railway_distributor" && customerType!=="super_stockist" && 

<SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
<Grid item xs={12} lg={12}>
<Card sx={{ overflow: "visible" }}>
<SoftBox p={3}>
<SoftTypography variant="h5" id="form_heading">Market Details</SoftTypography>

<Grid container spacing={3} >
  {Object.keys(formValues.marketDetails).map((day) => (
    <Grid item xs={12} key={day} style={{paddingTop: "0px", marginTop: "15px"}}>
      <Card sx={{ overflow: "hidden" }}>
        <SoftBox p={0}>
        <SoftTypography
        variant="h6"
        component="label"
        fontWeight="bold"
        
        style={{padding: "10px", marginBottom:"8px", backgroundColor:'#ccc', }}>{day}</SoftTypography>
          {formValues.marketDetails[day].map((row, index) => {
          
            return(
<>
            <Grid container spacing={1} key={index} style={{padding: "20px 20px", borderBottom: "1px dashed #ccc", position:'relative', display:'flex',flexWrap: 'nowrap', overflowX: 'auto'}}>
             
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Beat Name</SoftTypography>
                <SoftInput
                type="text"
                  value={row.beatName_1}
                  onChange={(e) => handleFormChange("beatName_1", e.target.value, index, day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Distance from Godown</SoftTypography>
                <SoftInput
                  type="number"
                  inputProps={{ step: "0.01" }}
                  value={row.distanceFromGodown_1}
                  onChange={(e) => handleFormChange("distanceFromGodown_1", e.target.value, index, day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Expected Daily Sales</SoftTypography>
                <SoftInput
                 type="number"
                 inputProps={{ step: "0.01" }}
                 value={row.expectedDailySales_1}
                  onChange={(e) => handleFormChange("expectedDailySales_1", e.target.value, index,day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Retailer</SoftTypography>
                <SoftInput
                 type="number"
                value={row.retailer_1}
                  onChange={(e) => handleFormChange("retailer_1", e.target.value, index,day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Wholesaler</SoftTypography>
                <SoftInput
                  type="number"
                  value={row.wholesaler_1}
                  onChange={(e) => handleFormChange("wholesaler_1", e.target.value, index, day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Frequency of Visit (Weekly)</SoftTypography>
                <SoftInput
                 type="text"
                 value={row.frequencyOfVisit_1}
                  onChange={(e) => handleFormChange("frequencyOfVisit_1", e.target.value, index, day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Ready Stock or Order booking</SoftTypography>
                <SoftInput
                  type="text"
                 value={row.readyStockOrOrderBooking_1}
                  onChange={(e) => handleFormChange("readyStockOrOrderBooking_1", e.target.value, index, day)}
                  size="medium"
                />
              </Grid>
              {/* {formValues.marketDetails[day].length > 1 && index!==0 && (
                 <div style={{width: "30px", height: "30px", backgroundColor: "#efefef", position:'absolute', right:'10px', cursor:'pointer', 
                 top:'25px', borderRadius:'50%', display:'flex', justifyContent:'center', alignItems:'center'}} onClick={() => removeRowMarket(day, index)}>
                 <CloseIcon/>
               </div>
                // <Grid item xs={2}>
                //   <SoftButton variant="contained" color="error" onClick={() => removeRowMarket(day, index)}>
                //     <DeleteIcon/>
                //   </SoftButton>
                // </Grid>
              )} */}
            </Grid>

            <Grid container spacing={1} key={index} style={{padding: "20px 20px", borderBottom: "1px dashed #ccc", position:'relative',display:'flex',flexWrap: 'nowrap', overflowX: 'auto'}}>
             
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Beat Name</SoftTypography>
               <SoftInput
               type="text"
                 value={row.beatName_2}
                 onChange={(e) => handleFormChange("beatName_2", e.target.value, index, day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Distance from Godown</SoftTypography>
               <SoftInput
                 type="number"
                 inputProps={{ step: "0.01" }}
                 value={row.distanceFromGodown_2}
                 onChange={(e) => handleFormChange("distanceFromGodown_2", e.target.value, index, day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Expected Daily Sales</SoftTypography>
               <SoftInput
                 type="number"
                 inputProps={{ step: "0.01" }}
                value={row.expectedDailySales_2}
                 onChange={(e) => handleFormChange("expectedDailySales_2", e.target.value, index,day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Retailer</SoftTypography>
               <SoftInput
                type="number"
               value={row.retailer_2} 
                 onChange={(e) => handleFormChange("retailer_2", e.target.value, index,day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Wholesaler</SoftTypography>
               <SoftInput
                 type="number"
                 value={row.wholesaler_2}
                 onChange={(e) => handleFormChange("wholesaler_2", e.target.value, index, day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Frequency of Visit (Weekly)</SoftTypography>
               <SoftInput
                type="text"
                value={row.frequencyOfVisit_2}
                 onChange={(e) => handleFormChange("frequencyOfVisit_2", e.target.value, index, day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Ready Stock or Order booking</SoftTypography>
               <SoftInput
                 type="text"
                value={row.readyStockOrOrderBooking_2}
                 onChange={(e) => handleFormChange("readyStockOrOrderBooking_2", e.target.value, index, day)}
                 size="medium"
               />
             </Grid>
             {/* {formValues.marketDetails[day].length > 1 && index!==0 && (
                <div style={{width: "30px", height: "30px", backgroundColor: "#efefef", position:'absolute', right:'10px', cursor:'pointer', 
                top:'25px', borderRadius:'50%', display:'flex', justifyContent:'center', alignItems:'center'}} onClick={() => removeRowMarket(day, index)}>
                <CloseIcon/>
              </div>
               // <Grid item xs={2}>
               //   <SoftButton variant="contained" color="error" onClick={() => removeRowMarket(day, index)}>
               //     <DeleteIcon/>
               //   </SoftButton>
               // </Grid>
             )} */}
           </Grid>
</>

            
            )
         })}
          {/* <SoftBox  p={2}>
            <SoftButton variant="contained" color="info" onClick={() => addRowMarket(day)}>
              Add Row
            </SoftButton>
          </SoftBox> */}
        </SoftBox>
      </Card>
    </Grid>
  ))}
</Grid>


</SoftBox>
</Card>
</Grid>
</Grid>
</SoftBox>
}


         <SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
       {/* Submit Button */}
       <Grid container justifyContent="flex-end" mt={2}>
         <Grid item>
          {(customerArr.length==0 || 
  (customerArr[0] &&
   (!customerArr[0].gstin_document || customerArr[0].gstin_document === "") &&
   (!customerArr[0].pan_card_document || customerArr[0].pan_card_document === "")))  && 
           <SoftButton type="submit" disabled={panGSTError|| panGSTError2} variant="contained" color="primary">
             Save & Continue
           </SoftButton>
          
          }
         </Grid>
       </Grid>

       {customerArr.length>0 &&
 customerArr[0] &&
 (
   (customerArr[0].gstin_document || customerArr[0].gstin_document !== "") &&
   (customerArr[0].pan_card_document || customerArr[0].pan_card_document !== "")
 )  &&(

       <>
         <SoftTypography variant="h5" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
           UPLOADED DOCUMENTS
         </SoftTypography>
         <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
           <tbody>
             <tr>
               <td><strong>GSTIN Document</strong></td>
               <td>{customerArr[0]?.gstin_document ? (
           <a
             href={`https://crm-backend.anmolindustries.com/${customerArr[0].gstin_document}`}
             target="_blank"
             rel="noopener noreferrer"
             style={{
               fontWeight: "bold",
               color: "#007bff",
               textDecoration: "none",
               display: "flex",
               alignItems: "center",
             }}
           >
             <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
           </a>
         ) : (
           ""
         )}</td>
               <td><strong>PAN Document</strong></td>
               <td>{customerArr[0]?.pan_card_document ? (
           <a
             href={`https://crm-backend.anmolindustries.com/${customerArr[0].pan_card_document}`}
             target="_blank"
             rel="noopener noreferrer"
             style={{
               fontWeight: "bold",
               color: "#007bff",
               textDecoration: "none",
               display: "flex",
               alignItems: "center",
             }}
           >
             <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
           </a>
         ) : (
           ""
         )}</td>
             </tr>
       
             <tr>
               <td><strong>FSSAI License Document</strong></td>
               <td>{customerArr[0]?.fssai_license_document ? (
           <a
             href={`https://crm-backend.anmolindustries.com/${customerArr[0].fssai_license_document}`}
             target="_blank"
             rel="noopener noreferrer"
             style={{
               fontWeight: "bold",
               color: "#007bff",
               textDecoration: "none",
               display: "flex",
               alignItems: "center",
             }}
           >
             <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
           </a>
         ) : (
           ""
         )}</td>
               <td><strong>TAN Document</strong></td>
               <td>{customerArr[0]?.tan_document ? (
           <a
             href={`https://crm-backend.anmolindustries.com/${customerArr[0].tan_document}`}
             target="_blank"
             rel="noopener noreferrer"
             style={{
               fontWeight: "bold",
               color: "#007bff",
               textDecoration: "none",
               display: "flex",
               alignItems: "center",
             }}
           >
             <RemoveRedEyeIcon style={{ marginLeft: "5px" ,color:'red'}} />
           </a>
         ) : (
           ""
         )}</td>
             </tr>
       
             <tr>
               <td><strong>Cancel Cheque Document</strong></td>
               <td>{customerArr[0]?.cancel_cheque_document ? (
           <a
             href={`https://crm-backend.anmolindustries.com/${customerArr[0].cancel_cheque_document}`}
             target="_blank"
             rel="noopener noreferrer"
             style={{
               fontWeight: "bold",
               color: "#007bff",
               textDecoration: "none",
               display: "flex",
               alignItems: "center",
             }}
           >
             <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
           </a>
         ) : (
           ""
         )}</td>
               <td><strong>Three undated cheques document</strong></td>
               <td>{customerArr[0]?.three_undated_cheques_document ? (
           <a
             href={`https://crm-backend.anmolindustries.com/${customerArr[0].three_undated_cheques_document}`}
             target="_blank"
             rel="noopener noreferrer"
             style={{
               fontWeight: "bold",
               color: "#007bff",
               textDecoration: "none",
               display: "flex",
               alignItems: "center",
             }}
           >
             <RemoveRedEyeIcon style={{ marginLeft: "5px" ,color:'red'}} />
           </a>
         ) : (
           ""
         )}</td>
             </tr>
       
             <tr>
               <td><strong>Address Proof Document</strong></td>
               <td>{customerArr[0]?.address_proof_document ? (
           <a
             href={`https://crm-backend.anmolindustries.com/${customerArr[0].address_proof_document}`}
             target="_blank"
             rel="noopener noreferrer"
             style={{
               fontWeight: "bold",
               color: "#007bff",
               textDecoration: "none",
               display: "flex",
               alignItems: "center",
             }}
           >
             <RemoveRedEyeIcon style={{ marginLeft: "5px" ,color:'red'}} />
           </a>
         ) : (
           ""
         )}</td>
             </tr>
            
           </tbody>
         </Table>
         </>
 )
       }
     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

         </form>

         <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
          <SimpleBackdrop openLoader={searchLoader}/>
                               <DialogTitle>Select an Option</DialogTitle>
                               <DialogContent>
               
                               <input
                         type="text"
                         placeholder="Search..."
                         value={searchTerm}
                         onChange={(e) => setSearchTerm(e.target.value)}
                         style={{
                           width: "100%",
                           padding: "5px",
                           marginBottom: "10px",
                           fontSize: "12px",
                         }}
                       />
                        <SoftButton
                     onClick={() => handleFormChange('godown_unit', "")}
                     style={{
                       marginBottom: "10px",
                       backgroundColor: "#ccc",
                       border: "none",
                       padding: "5px 10px",
                       fontSize: "12px",
                       cursor: "pointer",
                       borderRadius: "4px"
                     }}
                   >
                     Clear Selection
                   </SoftButton>
                               <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                               <thead>
                               <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                                       <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Label</th>
                                       <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                                     </tr>
                                   </thead>
                                   <tbody>
                                     {kdsdata &&
                                       filteredData?.map((item, index) => (
                                         <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={index} onClick={() => handleFormChange('godown_unit',item.value)}>
                                           <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.label}</th>
                                           <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.value}</th>
                                         </tr>
                                       ))}
                                   </tbody>
                                 </Table>
                               </DialogContent>
                             </Dialog> 

                              <Dialog open={dialogOpen2} onClose={() => setDialogOpen2(false)}>
                              <SimpleBackdrop openLoader={searchLoader}/>
                                                   <DialogTitle>Select an Option</DialogTitle>
                                                   <DialogContent>
                                   
                                                   <input
                                             type="text"
                                             placeholder="Search..."
                                             value={searchTerm2}
                                             onChange={(e) => setSearchTerm2(e.target.value)}
                                             style={{
                                               width: "100%",
                                               padding: "5px",
                                               marginBottom: "10px",
                                               fontSize: "12px",
                                             }}
                                           />
                                            <SoftButton
                                         onClick={() => handleFormChange(selectedZoneName, "")}
                                         style={{
                                           marginBottom: "10px",
                                           backgroundColor: "#ccc",
                                           border: "none",
                                           padding: "5px 10px",
                                           fontSize: "12px",
                                           cursor: "pointer",
                                           borderRadius: "4px"
                                         }}
                                       >
                                         Clear Selection
                                       </SoftButton>
                                                   <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                                                   <thead>
                                                   <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                                                           <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                                                         </tr>
                                                       </thead>
                                                       <tbody>
                               {
                                filteredZone?.filter(
                                  (item) =>
                                    item.toLowerCase().includes(debouncedSearch.toLowerCase())
                                )
                                 .map((item, idx) => (
                                       <tr
                                         key={idx}
                                         style={{ whiteSpace: 'nowrap', fontSize: "12px" }}
                                         onClick={() => handleFormChange(selectedZoneName, item)}
                                       >
                                         <td style={{ backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item}</td>
                                       </tr>
                                     )
                                   )
                               }
                             </tbody>
                                                     </Table>
                                                   </DialogContent>
                                                 </Dialog> 
         </SoftBox>
        
     </Grid>
     </>
    )
}

export default CustomerForm